export const PLANS = {
  FREE: 'trial',
  BASIC: 'basic',
  PRO: 'pro',
  ESSENTIAL: 'essential',
};

export const PLAN_STATUS = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  PENDING_CANCELATION: 'pending_cancelation',
  EXPIRED: 'expired',
};

const SUBSCRIPTIONS = {
  FREE: 'Free',
  BASIC: '$89/month | $1,015 annual (5% off)',
  PRO: '$129/month | $1,389 annually (10% off)',
};

const CUSTOMER_TRAINING_FEE = {
  FREE: 'n/a',
  BASIC: '$399',
  PRO: '$199 (50% off)',
};

export const SURVEY_LIMITS = {
  FREE: {
    NAME: PLANS.FREE,
    SURVEY: 1,
    SURVEY_PARTICIPANTS: 100,
    USER_ACCOUNTS: 1,
    ONBOARDING: false,
    CUSTOMER_SUPPORT: false,
    GROWTH_ADDONS: false,
    SMS_ADDONS: false,
    SUBSCRIPTION: SUBSCRIPTIONS.FREE,
    CUSTOMER_TRAINING_FEE: CUSTOMER_TRAINING_FEE.FREE,
  },

  BASIC: {
    NAME: PLANS.BASIC,
    SURVEY: 10,
    SURVEY_PARTICIPANTS: 1000,
    USER_ACCOUNTS: 2,
    ONBOARDING: true,
    CUSTOMER_SUPPORT: true,
    GROWTH_ADDONS: false,
    SMS_ADDONS: false,
    SUBSCRIPTION: SUBSCRIPTIONS.BASIC,
    CUSTOMER_TRAINING_FEE: CUSTOMER_TRAINING_FEE.BASIC,
  },

  PRO: {
    NAME: PLANS.PRO,
    SURVEY: 9999999,
    SURVEY_PARTICIPANTS: 9999999999,
    USER_ACCOUNTS: 999999,
    ONBOARDING: true,
    CUSTOMER_SUPPORT: true,
    GROWTH_ADDONS: true,
    SMS_ADDONS: true,
    SUBSCRIPTION: SUBSCRIPTIONS.PRO,
    CUSTOMER_TRAINING_FEE: CUSTOMER_TRAINING_FEE.PRO,
  },

  ESSENTIAL: {
    SURVEY: 9999999,
    SURVEY_PARTICIPANTS: 9999999999,
    USER_ACCOUNTS: 999999,
    ONBOARDING: true,
    CUSTOMER_SUPPORT: true,
    GROWTH_ADDONS: true,
    SMS_ADDONS: true,
  },
};



// WEBPACK FOOTER //
// ./src/constants/plans.js